import { render } from "./InvoiceStatusContainer.vue?vue&type=template&id=525b1996&scoped=true"
import script from "./InvoiceStatusContainer.vue?vue&type=script&lang=js"
export * from "./InvoiceStatusContainer.vue?vue&type=script&lang=js"

import "./InvoiceStatusContainer.vue?vue&type=style&index=0&id=525b1996&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-525b1996"]])

export default __exports__